<template>
  <div class="bdy_top">
    <el-container style="height: 100%">
      <!-- background-color="#001529"
        text-color="#fff"
        active-text-color="#FFF" -->
      <el-menu
        :collapse="isCollapse"
        background-color="#001529"
        text-color="#fff"
        active-text-color="#FFF"
      >
        <div class="left_menu">
          <!-- <div class="name_icon">
            <img class="login_icon" src="../../assets/logo.png"   />
          </div> -->

          <ul>
            <div class="user_names">
              <img class="user_names_img" :src="user.avatar" alt="" />
              <div class="user_names_name">{{ user.name }}</div>
            </div>
            <el-submenu
              :index="index"
              @click="clickClose(item)"
              v-show="datalist.length"
              v-for="(item, index) in datalist"
              :key="index"
              style="cursor: pointer"
            >
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  v-for="items in item.children"
                  :key="items.key"
                  :index="items.key"
                  @click="$router.push({ path: items.key })"
                >
                  <div class="title_left_icon_list">
                    <i class="title_left_icon"></i> {{ items.name }}
                  </div>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </ul>
        </div>
      </el-menu>
      <!-- <div class="menuMax" :class="!isCollapse?'openW':'hidenW'">
   
      <el-menu default-active="1-1" class="el-menu-vertical-demo"  
        active-text-color="#f00"
        unique-opened
        :collapse="isCollapse">
         
          <div class="user_names" >
            <img class="user_names_img" :src="user.avatar" v-if="!isCollapse" />
            <div class="user_names_name">{{ user.name }}</div>
          </div>
          
         <el-submenu
              :index="index"
              @click="clickClose(item)"
              v-show="datalist.length"
              v-for="(item, index) in datalist"
              :key="index"
              style="cursor: pointer"
            >
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  v-for="items in item.children"
                  :key="items.key"
                  :index="items.key"
                  @click="$router.push({ path: items.key })"
                >
                  <div class="title_left_icon_list">
                    <i class="title_left_icon"></i> {{ items.name }}
                  </div>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
      </el-menu>

    </div> -->
      <el-container>
        <el-header class="right_top" style="text-align: left; font-size: 12px">
          <!-- <div class="collapse-btn" @click="isCollapse=!isCollapse">
         
            <i class="menuIcon" :class="isCollapse?'el-icon-s-fold':'el-icon-s-unfold'" ></i> 
            <img class="login_icon" src="../../assets/logo.png"   />
        </div> -->

          <div class="right_button">
            <el-dropdown class="right_button">
              <img
                class="login_icon"
                style="margin: 0; margin-left: 20px"
                src="../../assets/logo.png"
              />
              <el-dropdown-menu slot="dropdown">
                <div
                  class="dropdown_lick"
                  style="color: #1890ff; cursor: pointer"
                  @click="gotlogin"
                >
                  退出登录
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>

        <el-main class="el_backgrund" style="padding: 0">
          <!-- <div class="el_backgrund_left">
            <el-container style="border: 1px solid #eee">
              <el-aside
                width="200px"
                style="background-color: rgb(238, 241, 246)"
              >
                <el-menu
                  class="el-menu-vertical-demo"
                  unique-opened
                  router
                  @select="setheadName"
                  :default-active="defaultActive"
                >
                  <el-submenu
                    v-for="item in leftList.children"
                    :key="item.key"
                    :index="`${item.key}`"
                  >
                    <template slot="title">
                      <i class="el-icon-menu"></i>
                      {{ item.name }}
                    </template>
                    <el-menu-item-group v-if="item.click">
                      <el-menu-item
                        v-for="(items, indexs) in item.children"
                        :key="indexs"
                        :index="items.key"
                        >{{ items.name }}</el-menu-item
                      >
                    </el-menu-item-group>
                    <el-menu-item v-else :index="`${item.key}`">{{
                      item.name
                    }}</el-menu-item>
                  </el-submenu>
                </el-menu>
              </el-aside>
            </el-container>
          </div> -->
          <div class="router_view">
            <HeadNavigation
              v-show="$root.headName.length"
              :datalist="datalist"
            />
            <router-view></router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import router_list from '../../router_list';
import HeadNavigation from '../../components/HeadNavigation';
export default {
  name: 'shop',
  components: {
    HeadNavigation,
  },
  data() {
    return {
      // 列表
      datalist: [],
      // 切换管理员页面
      administrators: {
        //是否管理员权限
        onOK: true,
        // 是否展示默认菜单
        clickName: '',
      },
      isCollapse: false,
      headNames: [{ name: '首页' }, { name: '首页' }],
      leftList: {},
      defaultActive: '',
      user: {
        avatar: '',
        name: '',
      },
    };
  },

  methods: {
    gotlogin() {
      console.log(111);
      localStorage.setItem('KC_token', '');
      this.$router.push({ path: '/login' });
    },
    // 点击跳转
    clickClose(key) {
      let router_path = this.$route.path;
      console.log(key);
      this.datalist.map((item) =>
        item.key === key.key
          ? (item.classNames = true)
          : (item.classNames = false)
      );
      if (key.children.length > 1) {
        this.leftList = key;
      }
      if (key.children[0].click) {
        router_path !== key.children[0].children[0].key &&
          this.$router.push({ path: key.children[0].children[0].key }); // let router_path = this.$route.path;
        this.defaultActive = key.children[0].children[0].key;
      } else {
        router_path !== key.children[0].key &&
          this.$router.push({ path: key.children[0].key }); // let router_path = this.$route.path;
        this.defaultActive = key.children[0].key;
      }
      this.setheadName();
    },

    getList() {
      const { list } = router_list;
      this.datalist = list;
    },
    // getType() {
    getType(item, list) {
      let router_path = this.router_path;
      if (!item.children || !item.children.length) {
        return;
      }
      const finds = item.children.find((items) => {
        if (router_path.indexOf(items.key) !== -1) {
          return items;
        }
      });
      if (finds) {
        this.$root.headName = [item.name, finds.name];
        list.length && this.$root.headName.unshift(list[0]);
        this.datalist.map((item) => {
          if (item.name === this.$root.headName[0]) {
            item.classNames = true;
            this.leftList = item;
            if (!this.defaultActive) {
              this.defaultActive = router_path;
            }
          }
          return item;
        });
        return finds;
      }
    },
    setheadName(e) {
      // let router_path = this.$route.path;
      this.router_path = e || this.$route.path;
      if (!this.defaultActive) {
        this.defaultActive = this.router_path;
      }
      this.datalist.map((item) => {
        if (item.key === this.router_path) {
          item.classNames = true;
          this.leftList = item;
          this.$root.headName = [item.name];
        } else {
          if (item.children) {
            item.children.map((items) => {
              if (items.key === this.router_path) {
                item.classNames = true;
                this.leftList = item;
                this.$root.headName = [item.name, items.name];
              } else {
                if (items.children) {
                  items.children.map((itemsx) => {
                    if (itemsx.key === this.router_path) {
                      item.classNames = true;
                      this.leftList = item;
                      this.$root.headName = [
                        item.name,
                        items.name,
                        itemsx.name,
                      ];
                    }
                  });
                }
              }
            });
          }
        }
      });
    },
  },

  created() {
    this.getList();
    this.$root.setheadName = this.setheadName;
    this.setheadName();
    if (localStorage.getItem('userInfo')) {
      this.user = JSON.parse(localStorage.getItem('userInfo'));
    }
  },
  mounted() {},
};
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 230px;
  min-height: 400px;
}

.menuMax {
  overflow-y: scroll;
}
.openW {
  width: 260px;
}
.hidenW {
  width: 260px;
}
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
  box-sizing: border-box;
}
.bdy_top {
  width: 100%;
  height: 100%;
}
.span_right {
  margin-right: 100px;
}
/* .is-active {
  color: #1890ff !important;
} */
.login_icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  /* margin-top: 20px; */
}
.name_icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.menuIcon {
  font-size: 30px;
}

.icon_size {
  font-size: 30px;
  width: 30px;
}
.right_top {
  display: flex;
  justify-content: flex-end;
  background: #fff;
  border-bottom: solid 1px #afafaf;
}
.collapse-btn {
}
.right_button {
  display: flex;
  align-items: center;
  text-align: right;
}
.button_click {
  width: 88px;
  height: 32px;
  background: #fff;
  color: #000;
  border-radius: 5px;
  border: solid 1px rgb(126, 126, 126);
}
.el_backgrund {
  background: #f0f2f5;
  display: flex;
  flex: 1;
  height: 100%;
  position: relative;
}

.el-menu-item-group >>> .el-menu-item-group__title {
  padding: 0;
}
.router_view {
  flex: 1;
  box-sizing: border-box;
  padding: 20px;
  /* height: calc(100% - 40px); */
  /* overflow: hidden; */
  overflow: auto;
}
.el-table__empty-block {
  width: 100% !important;
}
.left_menu {
  width: 200px;
  height: 100%;
  color: #fff;
  overflow-y: auto;
}
.left_menu::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.left_menu_li:hover {
  color: #fff;
}
.left_menu_li {
  display: flex;
  position: relative;
  /* justify-content: center; */
  color: rgba(255, 255, 255, 0.5);
  margin: 20px 0;
  margin-left: 20px;
  align-items: center;
  font-size: 15px;
}
.left_menu_lis {
  display: flex;
  position: relative;
  /* justify-content: center; */
  color: rgba(255, 255, 255, 1);
  margin: 20px 0;
  align-items: center;
  margin-left: 20px;
  font-size: 15px;
}
.left_menu_lis .right_icon_shop {
  width: 5px;
}
.right_icon_shop {
  width: 0;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  right: 10px;
  border-radius: 2.5px;
}
.left_menu_li:hover .right_icon_shop {
  width: 5px;
}
.el_backgrund_left {
  width: auto;
  height: 100%;
  background: #fff;
}
.el_backgrund_left_s {
  font-size: 15px;
  color: rgb(53, 53, 53);
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.el_backgrund_left_sl {
  font-size: 12px;
  color: rgb(139, 139, 139);
  width: auto;
  height: 30px;
  margin: 20px 20px;
  line-height: 30px;
  text-align: center;
  /* margin-left: 10%; */
  border-radius: 10px;
  color: #000;
  padding: 0 20px;
}
.el_backgrund_left_sl:hover {
  background: rgb(238, 238, 238);
}
.el_backgrund_left_sls {
  font-size: 12px;
  color: rgb(139, 139, 139);
  width: auto;
  height: 30px;
  margin: 20px 20px;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;
  color: #000;
  background: rgb(238, 238, 238);
  padding: 0 20px;
}
.dropdown_lick {
  width: 100%;
  /* text-align: center; */
  margin: 0 10px;
}

.user_names {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 0;
  border-top: solid 1px #fff;
  border-bottom: solid 1px #fff;
  /* color: #333; */
  /* margin: 20px 0; */
}
.user_names_img {
  border-radius: 50%;
  overflow: hidden;
  width: 30px;
  background: #fff;
  margin-right: 20px;
  margin-left: 20px;
}
.user_names_name {
}
.title_left_icon_list {
  display: flex;
  align-items: center;
}
.title_left_icon {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: solid 2px #fff;
  display: block;
  margin-right: 10px;
}
</style>
